/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Vi bruker informasjonskapsler til å spore besøk til nettstedet vårt. Vi lagrer ikke personopplysninger.',
    cookiesAccept: 'Godta informasjonskapsler',
    cookiesDeny: 'Avvis informasjonskapsler',
    tabFAQs: 'Vanlige spørsmål',
    tabSupport: 'Brukerstøtte',
    tabHistory: 'Historie',
    tabReviews: 'Historier',
    tabTraining: 'Opplæring',
    tabUserTraining: 'Brukeropplæring',
    tabHcpTraining: 'Helseopplæring',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Graviditet',
    tabAbout: 'Om oss',
    tabNews: 'Nyheter',
    tabCareers: 'Karriere',
    tabOrders: '',
    tabNotifications: 'Varsler',
};
